<template>
  <div class="agent-response-buttons-container">
    <div class="agent-response-buttons-group" v-if="props.model?.type === MessageType.Agent">
      <img
        :src="copyActionIcon"
        :aria-label="t('chat.agent.agentResponseButtonCopy.alt')"
        :alt="t('chat.agent.agentResponseButtonCopy.alt')"
        :title="t('chat.agent.agentResponseButtonCopy.alt')"
        v-on:click="handleButtonClick('copy')"
      />
      <img
        :src="appStore.currentMode() === DisplayMode.Light ? iconThumbUpLight : iconThumbUpDark"
        :aria-label="t('chat.agent.agentResponseButtonThumbUp.alt')"
        :alt="t('chat.agent.agentResponseButtonThumbUp.alt')"
        :title="t('chat.agent.agentResponseButtonThumbUp.alt')"
        v-on:click="handleButtonClick('thumbUp')"
      />
      <img
        :src="appStore.currentMode() === DisplayMode.Light ? iconThumbDownLight : iconThumbDownDark"
        :aria-label="t('chat.agent.agentResponseButtonThumbDown.alt')"
        :alt="t('chat.agent.agentResponseButtonThumbDown.alt')"
        :title="t('chat.agent.agentResponseButtonThumbDown.alt')"
        v-on:click="handleButtonClick('thumbDown')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { MessageType } from '../../types/chat/MessageType'
import { t } from '../../composables/Translation'
import type { Message } from '../../types/chat/Message'
import iconThumbUpLight from '../../assets/icons/light/icon-thumb-up.svg'
import iconThumbUpDark from '../../assets/icons/dark/icon-thumb-up.svg'
import iconThumbDownLight from '../../assets/icons/light/icon-thumb-down.svg'
import iconThumbDownDark from '../../assets/icons/dark/icon-thumb-down.svg'
import { useAppStore } from '../../stores/appStore'
import { FeedbackGrade } from '../../types/FeedbackGrade'
import { DisplayMode } from '../../types/app/displayMode'

const appStore = useAppStore()

const props = defineProps<{
  model: Message | undefined
  copyActionIcon: string | undefined
}>()
const emit = defineEmits<{
  (e: 'copy-agent-response'): void
  (e: 'open-feedback-modal', grade: FeedbackGrade): void
}>()

function handleButtonClick(button: string) {
  if (button === 'copy') {
    emit('copy-agent-response')
    console.log('Copy agent response button click')
  }
  if (button === 'thumbUp') {
    emit('open-feedback-modal', FeedbackGrade.ThumbUp)
    console.log('Open feedback modal thumb up click')
    // appStore.feedbackModalStateChange(FeedbackModalState.OpenThumbUp)
  }
  if (button === 'thumbDown') {
    emit('open-feedback-modal', FeedbackGrade.ThumbDown)
    console.log('Open feedback modal thumb down click')
    // appStore.feedbackModalStateChange(FeedbackModalState.OpenThumbDown)
  }
}
</script>

<style scoped lang="scss">
.agent-response-buttons-group {
  display: flex;
  padding: 0 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}
.agent-response-buttons-group img {
  color: #000;
  padding: 5px;
  border: 0px;
  border-radius: 8px;
  cursor: pointer;
}
.agent-response-buttons-group img:hover {
  background-color: var(--text-background-color);
  color: #000;
}
.agent-response-buttons-container {
  padding-bottom: 32px;
  margin-right: auto;
  padding-left: 46px;
  padding-right: 46px;
  padding-top: 12px;
}
</style>
